import React, { useRef, useState, useLayoutEffect } from 'react';

const BRANDS = ['Профітроль', 'Jobalto'];
const SALAD_GREEN = 'rgba(185, 248, 51, 1)';
const DARK_GREEN = 'rgba(121, 201, 18, 1)';

const PATTERN = new RegExp(`(${BRANDS.join('|')})`, 'gi');

const isBrand = (str) =>
  BRANDS.some((b) => b.toLowerCase() === String(str).toLowerCase());

const parseRgb = (str) => {
  const m = String(str).match(/(\d+)[,\s]+(\d+)[,\s]+(\d+)/);
  if (!m) return null;
  return [Number(m[1]), Number(m[2]), Number(m[3])];
};

const isLightBg = (rgbStr) => {
  const rgb = parseRgb(rgbStr);
  if (!rgb) return true;
  const [r, g, b] = rgb;
  return (r * 0.299 + g * 0.587 + b * 0.114) / 255 > 0.5;
};

const getEffectiveBg = (el) => {
  let cur = el;
  while (cur) {
    const bg = window.getComputedStyle(cur).backgroundColor;
    if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
    cur = cur.parentElement;
  }
  return 'rgb(255, 255, 255)';
};

const BrandText = ({ children }) => {
  const ref = useRef(null);
  const [color, setColor] = useState(SALAD_GREEN);

  useLayoutEffect(() => {
    if (typeof window === 'undefined' || !ref.current?.parentElement) return;
    const bg = getEffectiveBg(ref.current.parentElement);
    setColor(isLightBg(bg) ? DARK_GREEN : SALAD_GREEN);
  }, []);

  return <span ref={ref} style={{ color }}>{children}</span>;
};

const highlightBrand = (text) => {
  if (!text) return text;
  const parts = String(text).split(PATTERN);
  return (
    <span>
      {parts.map((part, i) =>
        isBrand(part) ? (
          <BrandText key={i}>{part}</BrandText>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </span>
  );
};

export default highlightBrand;
